<template>
  <div class="guide-info">
    <div class="guide-qr-title">首次学习需要长按二维码</div>
    <div class="guide-qr-info">添加服务老师</div>
    <img :src="guideQrCode" class="guide-qr-code" alt="">
    <div class="guide-qr-tip">添加后，重新进入课程页面，即可继续学习</div>
  </div>
</template>
<script>
export default {
  name: 'GuideInfo',
  props: {
    guideQrCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.guide-info {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: #fff;
  padding: 5.33vw 0;
  border-radius: 4.266vw 4.266vw 0 0;

  .guide-qr-title {
    font-weight: bold;
    font-size: 18px;
    color: #242424;
  }
  .guide-qr-info {
    font-size: 16px;
    color: #0E8BFF;
    margin: 1.066vw 0;
  }
  .guide-qr-code {
    width: 53.333vw;
    height: 53.333vw;
  }
  .guide-qr-tip {
    font-size: 16px;
    color: #676769;
    margin: 1.066vw 0;
  }
}
</style>
